import {assertAndContinue} from 'Asserts';
import {makeReactContext} from 'lib/makeReactContext';

const WritableContext = makeReactContext(() => {
  assertAndContinue(
    false,
    'Could not find writable context while rendering analytics component, defaulting to false'
  );
  return false;
}, 'WritableContext');

export function useWritableContext(): boolean {
  return WritableContext.useContext();
}

export default WritableContext;
